module.exports = __webpack_public_path__ + "static/media/eduardo-pinzon.a863861f.jpg";